import _ from 'lodash'
import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons'

const ErrorBlockRoot = styled.div(({theme}) => ({
	borderRadius: theme.borderRadius,
	padding: theme.spacing(2, 2.5),
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(1),
	backgroundColor: theme.colors.stopRed,
	color: theme.colors.white,
	justifyContent: 'center',
	alignItems: 'flex-start',
	textAlign: 'left',
	...theme.fonts.mono,
	fontSize: '0.75em',
	wordBreak: 'break-word',
}))

const ErrorBlockTitle = styled.div(({theme}) => ({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: theme.spacing(1),
}))

const ErrorBlockBullets = styled.ul({
	margin: 0,
})

interface L1ErrorBlockProps {
	title?: string
	content?: string
	bullets?: string[]
}

const L1ErrorBlock = ({title = 'ERROR', content, bullets}: L1ErrorBlockProps) => {
	return (
		<ErrorBlockRoot>
			<ErrorBlockTitle><FontAwesomeIcon icon={faCircleExclamation}/> {title}</ErrorBlockTitle>
			{content ? <div>{content}</div> : null}
			{bullets ? (
				<ErrorBlockBullets>
					{bullets.map((item, idx) => <li key={idx}>{item}</li>)}
				</ErrorBlockBullets>
			) : null}
		</ErrorBlockRoot>
	)
}

export default L1ErrorBlock
